<template>
    <div class="grade-bar-container">
        <div class="grade_item-container">
            <h2 class="grade_item-name">Фильтр</h2>
            <v-form class="grade_item-filter-wrap">
                <v-row style="width: 90%;" v-if="full">
                    <v-col cols="12" md="4" lg="3" class="filter-item">
                        <h3 class="filter-item-name">Факультет</h3>
                        <v-autocomplete
                            label=""
                            :items="faculties.list"
                            variant="outlined"
                            hide-details=""
                            item-value="id"
                            item-text="name"
                            class="filter-item-combobox"
                            v-model="faculties.selected"
                            :disabled="faculties.list === null"
                            :loading="faculties.list === null"
                            :search-input.sync="faculties.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                                <span style="width: 80%;" v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ faculties.selected.length - 1 }} еще выбранных(й)
                                </span>
                        </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Курс</h3>
                        <v-autocomplete
                            label=""
                            :items="studyCourse.list"
                            variant="outlined"
                            hide-details=""
                            item-text="name"
                            item-value="id"
                            class="filter-item-combobox"
                            v-model="studyCourse.selected"
                            :disabled="studyCourse.selected === null"
                            :loading="studyCourse.list === null"
                            :search-input.sync="studyCourse.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ studyCourse.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Группа</h3>
                        <v-autocomplete
                            label=""
                            hide-details
                            :items="groups.list"
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="groups.selected"
                            :disabled="groups.list === null"
                            :loading="groups.list === null"
                            :search-input.sync="groups.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ groups.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="3" class="filter-item">
                        <h3 class="filter-item-name">ФИО студента</h3>
                        <v-autocomplete
                            label=""
                            hide-details
                            return-object
                            :items="students.list"
                            item-value="fio"
                            item-text="fio"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="students.selected"
                            :disabled="students.list === null"
                            :loading="students.list === null"
                            :search-input.sync="students.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" >{{ item.fio }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ students.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Тип теста</h3>
                        <v-autocomplete
                            label=""
                            :items="testTypes.list"
                            hide-details
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="testTypes.selected"
                            :search-input.sync="testTypes.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ testTypes.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" class="filter-item">
                        <h3 class="filter-item-name">Дисциплина</h3>
                        <v-autocomplete
                            label=""
                            :items="subjects.list"
                            hide-details
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="subjects.selected"
                            :disabled="subjects.list === null"
                            :loading="subjects.list === null"
                            :search-input.sync="subjects.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ subjects.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" class="filter-item">
                        <h3 class="filter-item-name">Тема</h3>
                        <v-autocomplete
                            label=""
                            :items="topics.list"
                            hide-details
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="topics.selected"
                            :disabled="topics.list === null"
                            :loading="topics.list === null"
                            :search-input.sync="topics.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ topics.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" class="filter-item">
                        <h3 class="filter-item-name">Задание</h3>
                        <v-autocomplete
                            label=""
                            :items="exercise.list"
                            hide-details
                            item-value="id"
                            item-text="title"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="exercise.selected"
                            :disabled="exercise.list === null"
                            :loading="exercise.list === null"
                            :search-input.sync="exercise.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" >{{ item.title }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ exercise.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Дата прохождения</h3>
                        <div class="filter-item-date">
                            <span>от</span>
                            <v-menu
                                v-model="dates.begin.menu"
                                :close-on-content-click="false"
                                :nudge-right="calendarNudge"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        :value="dates.begin.formatted"
                                        @input="inputDate($event, dates.begin)"
                                        readonly
                                        prepend-icon="mdi-calendar"
                                        placeholder="__.__.____"
                                        clearable
                                    />
                                </template>
                                <v-date-picker
                                    :min="dates.min"
                                    :max="dates.end.value !== null ? dates.end.value : dates.max"
                                    v-model="dates.begin.value"
                                    @input="inputDate($event, dates.begin)"
                                    no-title
                                    scrollable
                                />
                            </v-menu>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2" class="filter-item">
                        <div class="filter-item-date">
                            <span>до</span>
                            <v-menu
                                v-model="dates.end.menu"
                                :close-on-content-click="false"
                                :nudge-right="calendarNudge"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        :value="dates.end.formatted"
                                        @input="inputDate($event, dates.end)"
                                        readonly
                                        prepend-icon="mdi-calendar"
                                        placeholder="__.__.____"
                                        clearable
                                    />
                                </template>
                                <v-date-picker
                                    :min="dates.begin.value !== null ? dates.begin.value : dates.min"
                                    :max="dates.max"
                                    v-model="dates.end.value"
                                    @input="inputDate($event, dates.end)"
                                    no-title
                                    scrollable
                                />
                            </v-menu>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Вид теста</h3>
                        <v-autocomplete
                            hide-details
                            label=""
                            :items="passTypes.list"
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="passTypes.selected"
                            :disabled="passTypes.list === null"
                            :loading="passTypes.list === null"
                            :search-input.sync="passTypes.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Тип теста</h3>
                        <v-autocomplete
                            hide-details
                            label=""
                            :items="testTypes.list"
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="testTypes.selected"
                            :search-input.sync="testTypes.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Дата прохождения</h3>
                        <div class="filter-item-date">
                            <span>от</span>
                            <v-menu
                                v-model="dates.begin.menu"
                                :close-on-content-click="false"
                                :nudge-right="calendarNudge"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        :value="dates.begin.formatted"
                                        @input="inputDate($event, dates.begin)"
                                        readonly
                                        prepend-icon="mdi-calendar"
                                        placeholder="__.__.____"
                                        clearable
                                    />
                                </template>
                                <v-date-picker
                                    :min="dates.min"
                                    :max="dates.end.value !== null ? dates.end.value : dates.max"
                                    v-model="dates.begin.value"
                                    @input="inputDate($event, dates.begin)"
                                    no-title
                                    scrollable
                                />
                            </v-menu>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2" class="filter-item">
                        <div class="filter-item-date">
                            <span>до</span>
                            <v-menu
                                v-model="dates.end.menu"
                                :close-on-content-click="false"
                                :nudge-right="calendarNudge"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        :value="dates.end.formatted"
                                        @input="inputDate($event, dates.end)"
                                        readonly
                                        prepend-icon="mdi-calendar"
                                        placeholder="__.__.____"
                                        clearable
                                    />
                                </template>
                                <v-date-picker
                                    :min="dates.begin.value !== null ? dates.begin.value : dates.min"
                                    :max="dates.max"
                                    v-model="dates.end.value"
                                    @input="inputDate($event, dates.end)"
                                    no-title
                                    scrollable
                                />
                            </v-menu>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="3" class="filter-item">
                        <h3 class="filter-item-name">Дисциплина</h3>
                        <v-autocomplete
                            hide-details
                            label=""
                            :items="subjects.list"
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="subjects.selected"
                            :disabled="subjects.list === null"
                            :loading="subjects.list === null"
                            :search-input.sync="subjects.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6" lg="3" class="filter-item">
                        <h3 class="filter-item-name">Тема</h3>
                        <v-autocomplete
                            hide-details
                            label=""
                            :items="topics.list"
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="topics.selected"
                            :disabled="topics.list === null"
                            :loading="topics.list === null"
                            :search-input.sync="topics.searchInput"
                            @change="update"
                            placeholder="Все"
                            clearable
                            multiple
                        ></v-autocomplete>
                    </v-col>
                </v-row>
            </v-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { helpers } from '@/store/tests';
import './index.scss';

export default {
    name: 'GradeFilters',
    props: {
        full: Boolean
    },
    data: () => ({
        studyCourse: {
            list: [],
            selected: [],
            searchInput: ''
        },
        faculties: {
            list: [],
            selected: [],
            searchInput: ''
        },
        groups: {
            list: null,
            selected: [],
            searchInput: ''
        },
        students: {
            list: null,
            selected: [],
            searchInput: ''
        },
        passTypes: {
            list: [],
            selected: [],
            searchInput: ''
        },
        testTypes: {
            list: [],
            selected: [],
            searchInput: ''
        },
        subjects: {
            list: null,
            selected: [],
            searchInput: ''
        },
        topics: {
            all: [],
            list: null,
            selected: [],
            searchInput: ''
        },
        exercise: {
            all: [],
            list: null,
            selected: [],
            searchInput: ''
        },
        dates: {
            begin: {
                value: null,
                formatted: null,
                menu: false
            },
            end: {
                value: null,
                formatted: null,
                menu: false
            },
            min: null,
            max: null
        },
        params: {
            filters: [],
            sortOption: {
                fieldName: '',
                sortType: 2
            },
            pageSize: 10000,
            currentPage: 0,
            useANDoperator: false,
            columns: []
        },
        organizationUnit: [],
        calendarNudge: 0
    }),
    computed: {
		...mapGetters({
            apiUrl: 'apiUrl',
            apiGuide: 'apiGuide'
		}),
    },
    methods: {
        setCalendarNudge() {
            let size = 290;
            let offset = 55;
            this.calendarNudge = window.innerWidth >= 400 ? 34 : (window.innerWidth - size) / 2 - offset;
        },
        setDates() {
            const date = new Date();
            this.dates.max = date.toISOString().split("T")[0];

            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            this.dates.min = new Date(year - 1, month, day).toISOString().split("T")[0];
        },
        inputDate(value, date) {
            date.value = value;
            date.formatted = this.formatDate(date.value);
            date.menu = false;
            this.update();
        },
        formatDate(date) {
            if (!date) {
                return null;
            }

            const [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`;
        },
        loadLookups() {
            if (this.full) {
                this.$http.post(`${this.apiUrl}Student/GetAll`, this.params)
                .then((result) => {
                        this.students.list = this.sortArray(result.data.data, 'fio');
                });

                this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetFacultiesByCurrentUser`)
                    .then((result) => {
                        this.faculties.list = this.sortArray(result.data, 'name');
                });
            } else {
                this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                    .then((result) => {
                        this.passTypes.list = this.sortArray(result.data, 'name');
                });
            }

            for (let i = 0; i < helpers.testTypes.length; i++) {
                this.testTypes.list.push({ id: i.toString(), name: helpers.testTypes[i] });
            }
            this.$http.get(`${this.apiUrl}api/SprStudyDiscipline/GetAll`)
                .then((result) => {
                    this.subjects.list = this.sortArray(result.data, 'name');
            });
            this.$http.post(`${this.apiUrl}TestTask/GetAll`, this.params)
                .then((result) => {
                    this.exercise.list = this.sortArray(result.data.data, 'title');
            });
                this.$http.post(`${this.apiUrl}DiaTest/GetAll`, this.params)
                .then((result) => {
                    for (let index = 0; index < result.data.data.length; index++) {
                        this.exercise.list.push(result.data.data[index])
                    }
                    console.log(this.exercise.list);

            });
            this.$http.post(`${this.apiUrl}SprOrganizationUnit/GetAll`, {})
                .then((result) => {
                    this.organizationUnit = result.data;
                    console.log(this.organizationUnit);
            });
            this.$http.get(`${this.apiUrl}api/SprDisciplineTopic/GetTopicsWithDisciplines`)
                .then((result) => {
                    this.topics.all = result.data;
                    this.topics.list = this.sortArray(this.topics.all, 'name');
            });
        },
        sortArray(array, name) {
            return array.sort((a, b) => {
                if (a[name] < b[name]) {
                    return -1;
                }

                if (a[name] > b[name]) {
                    return 1;
                }

                return 0;
            })
        },
        update() {
            let filters = [];
            if (this.faculties.selected.length > 0) {
                this.getCourse(this.faculties.selected);
                filters.push({
                    fieldName: 'facultyId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.faculties.selected
                });
                this.getUnit();
                this.studyCourse.searchInput = '';
            }
            else{
                this.getCourse();
            }
            if (this.studyCourse.selected.length > 0) {
                this.getGroups(this.faculties.selected, this.studyCourse.selected);
                filters.push({
                    fieldName: 'studyCourseId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.studyCourse.selected
                });

                this.studyCourse.searchInput = '';
            }
            else{
                this.getGroups();
            }

            if (this.students.selected.length > 0) {
                for (let i = 0; i < this.students.selected.length; i++) {
                    filters.push({
                    fieldName: 'UserFio',
                    filterType: 2,
                    filterValueType: 1,
                    value1: this.students.selected[i].fio
                });

                }


                this.students.searchInput = '';
            }

            if (this.groups.selected.length > 0) {
                filters.push({
                    fieldName: 'studyGroupId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.groups.selected
                });

                this.groups.searchInput = '';
            }

            if (this.passTypes.selected.length > 0) {
                filters.push({
                    fieldName: 'passTypeId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.passTypes.selected
                });

                this.passTypes.searchInput = '';
            }

            if (this.testTypes.selected.length > 0) {
                if (this.testTypes.selected.length === 2 || this.testTypes.selected.length === 0 ) {
                    this.$http.post(`${this.apiUrl}TestTask/GetAll`, this.params)
                    .then((result) => {
                        this.exercise.list = this.sortArray(result.data.data, 'title');
                     });
                     this.$http.post(`${this.apiUrl}DiaTest/GetAll`, this.params)
                    .then((result) => {
                        for (let index = 0; index < result.data.data.length; index++) {
                            this.exercise.list.push(result.data.data[index])
                        }
                        console.log(this.exercise.list);

                    });
                }
                if (this.testTypes.selected[0] === "0") {
                    this.$http.post(`${this.apiUrl}TestTask/GetAll`, this.params)
                    .then((result) => {
                        this.exercise.list = this.sortArray(result.data.data, 'title');
                     });
                }
                if (this.testTypes.selected[0] === "1") {
                     this.$http.post(`${this.apiUrl}DiaTest/GetAll`, this.params)
                    .then((result) => {
                        for (let index = 0; index < result.data.data.length; index++) {
                            this.exercise.list = result.data.data
                        }
                        console.log(this.exercise.list);

                    });
                }

                filters.push({
                    fieldName: 'testType',
                    filterType: 9,
                    filterValueType: 2,
                    values: this.testTypes.selected
                });

                this.testTypes.searchInput = '';
            }
            if (this.exercise.selected.length > 0) {
                filters.push({
                    fieldName: 'TestId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.exercise.selected
                });

                this.testTypes.searchInput = '';
            }

            if (this.dates.begin.value !== null) {
                filters.push({
                    fieldName: 'date',
                    filterType: 4,
                    filterValueType: 1,
                    value1: this.dates.begin.value
                });
            }

            if (this.dates.end.value !== null) {
                filters.push({
                    fieldName: 'date',
                    filterType: 5,
                    filterValueType: 1,
                    value1: this.dates.end.value + ' 23:59:59'
                });
            }

            if (this.subjects.selected.length > 0) {
                this.getTopic(this.subjects.selected,this.topics.list )
                filters.push({
                    fieldName: 'subjectId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.subjects.selected
                });

                this.subjects.searchInput = '';

                let filteredTopics = this.topics.all
                    .filter(x => this.subjects.selected
                        .some(y => x.disciplineIds.includes(y)));

                this.topics.list = this.sortArray(filteredTopics, 'name');
                this.topics.selected = this.topics.selected.filter(x => filteredTopics.map(y => y.id).includes(x));
            } else {
                this.loadLookups()
                this.topics.list = this.sortArray(this.topics.all, 'name');
            }

            if (this.topics.selected.length > 0) {
                this.getExercise(this.topics.selected, this.exercise.list)
                filters.push({
                    fieldName: 'topicId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.topics.selected
                });

                this.topics.searchInput = '';
            }
            else{
                this.loadLookups()
            }

            this.$emit('update', filters);
        },
        getCourse(arrayIds) {
         let queryParamsFaculties = '';
         if (arrayIds != null) {
            for (let i = 0; i < arrayIds.length; i++) {
                queryParamsFaculties += `${i === 0 ? '?' : '&'}`;
                queryParamsFaculties += `facultyIds=${arrayIds[i]}`
            }
         }
            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetStudyCourses${queryParamsFaculties ? queryParamsFaculties : ''}`)
                .then((response) => {
                    this.studyCourse.list = response.data;
                    this.loadingListCourse = false;
                    // this.toggleAllCourse();
                });
        },
        getTopic(arrayIds, arrIds) {
        console.log(arrayIds, arrIds);
        this.topics.list = []
         if (arrayIds != null) {
            for (let i = 0; i < arrayIds.length; i++) {
                for (let j = 0; j < arrIds.length; j++) {
                    console.log(arrayIds[i], arrIds[j].disciplineIds[0]);
                    if (arrayIds[i] === arrIds[j].disciplineIds[0]) {
                        console.log('11');
                        this.topics.list.push(arrIds[j])
                    }
                }
            }
            console.log(this.topics.list);
         }
        },
        getExercise(arrayIds, arrIds) {
        console.log(arrayIds, arrIds);
        this.exercise.list = []
         if (arrayIds != null) {
            for (let i = 0; i < arrayIds.length; i++) {
                for (let j = 0; j < arrIds.length; j++) {
                    console.log(arrayIds[i], arrIds[j].studyTopicId);
                    if (arrayIds[i] === arrIds[j].studyTopicId) {
                        console.log('11');
                        this.exercise.list.push(arrIds[j])
                    }
                }
            }
            console.log(this.exercise.list);
         }
        },
        getGroups(facultyIds,courseIds) {
         let queryParamsFaculties = '';
         let queryParamsCourse = '';

         if (facultyIds != null) {
            for (let i = 0; i < facultyIds.length; i++) {
                queryParamsFaculties += `${i === 0 ? '?' : '&'}`;
                queryParamsFaculties += `facultyIds=${facultyIds[i]}`
            }
         }
         if (courseIds != null) {
            for (let i = 0; i < courseIds.length; i++) {
                queryParamsCourse += `${'&'}`;
                queryParamsCourse += `courseIds=${courseIds[i]}`
            }
         }
            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetStudyGroups${queryParamsFaculties ? queryParamsFaculties : ''}${queryParamsCourse ? queryParamsCourse : ''}`)
                .then((response) => {
                    this.groups.list = response.data;
                    if(facultyIds != null && courseIds!=null && this.groups.selected != 0){
                        this.$http.post(`${this.apiUrl}Student/GetAll`, {
                filters: [{
                    fieldName: 'facultyId',
                    filterType: 9,
                    filterValueType: 1,
                    value1: '',
                    value2: '',
                    values: facultyIds
                },{
                    fieldName: 'studyCourseId',
                    filterType: 9,
                    filterValueType: 1,
                    value1: '',
                    value2: '',
                    values: courseIds
                },{
                    fieldName: 'groupId',
                    filterType: 9,
                    filterValueType: 1,
                    value1: '',
                    value2: '',
                    values: this.groups.selected ? this.groups.selected : ''
                }],
                sortOption: {
                    fieldName: 'fio',
                    sortType: 2
                },
                pageSize: 999999,
                currentPage: 0,
                useANDoperator: true,
                columns: []
            })
            .then((response) => {
                this.students.list = response.data.data;
            });
                    }
                });
        },
        getUnit(){
            this.$http.post(`${this.apiUrl}SprOrganizationUnit/GetAll`, this.params)
            .then((result) => {
                console.log(result.data.data);
            });
        },
        allResetFilters() {
            let arr = ['studyCourse', 'faculties', 'groups', 'students', 'passTypes', 'testTypes', 'subjects', 'topics', 'exercise'];

            for (let i = 0; i < arr.length; i++) {
                let object = this[arr[i]];

                for (const key in object) {
                    if (Object.hasOwnProperty.call(object, key)) {
                        if(key === 'selected') object[key] = [];
                        if(key === 'searchInput') object[key] = '';
                    }
                }
            }

            this.dates = {
                begin: {
                    value: null,
                    formatted: null,
                    menu: false
                },
                end: {
                    value: null,
                    formatted: null,
                    menu: false
                },
                min: null,
                max: null
            };
        }
    },
	mounted() {
		this.$root.$on('resetFilters', () => { this.allResetFilters() })
	},
    created() {
        this.getCourse();
        this.getGroups();
        this.setCalendarNudge();
        this.setDates();
        this.loadLookups();
    }
}
</script>

<style scoped lang="scss">
.grade_item-filter-wrap {
    align-self: stretch;
    .filter-item {
        align-self: end;
        .filter-item-name {
            margin-bottom: 4px;
            color: #2B2D33;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 26px; /* 185.714% */
        }
        .filter-item-combobox {
            width: 100%;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px; /* 157.143% */
            border-radius: 8px;
            border: 1px solid #CACDD3;
        }
        .filter-item-date {
            width: 100%;
            display: flex;
            gap: 10px;
            span {
                margin-top: 10px;
                color: #AAAEB7;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }
        }
    }
}
</style>
